export const FALLBACK_LANGUAGE = {
  isRTL: false,
  languageTag: 'ru',
};

export enum LanguageTags {
  ru = 'ru',
  en = 'en',
  es = 'es',
  id = 'id',
  de = 'de',
  fr = 'fr',
  hi = 'hi',
  hu = 'hu',
  it = 'it',
  th = 'th',
  ro = 'ro',
  ko = 'ko',
  pl = 'pl',
  pt = 'pt',
  tr = 'tr',
  ja = 'ja',
  bg = 'bg',
}
